"use client";

import React from "react";
import Image from "../../assets/images/Connect.jpeg"

export function ComprehensiveSecurityAssessment() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-[#CCE2E3]">
      <div className="container md:max-w-5xl lg:max-w-7xl mx-auto">
        <div className="mb-12 grid grid-cols-1 items-start justify-between gap-x-12 gap-y-8 md:mb-18 md:grid-cols-2 md:gap-x-12 md:gap-y-8 lg:mb-20 lg:gap-x-20">
          <h3 className="text-4xl  leading-[1.2] md:text-[30px] lg:text-[30px] max-w-[450px]">
          Umfassende Sicherheitsbewertung und Risikoanalyse für die Cybersicherheit Ihres Unternehmens
          </h3>
          <p className="md:text-md w-full max-w-[500px]">
          Unsere Dienstleistungen zur Sicherheitsbewertung und Risikoanalyse sind darauf ausgerichtet, Schwachstellen zu ermitteln und Ihre Cybersicherheit zu verbessern. Mit Penetrationstests simulieren wir reale Angriffe, um Schwachstellen in Ihren Systemen aufzudecken. Darüber hinaus bieten unsere Bedrohungsmodellierung und Sicherheitsanalyse maßgeschneiderte Strategien zum Schutz Ihres Unternehmens vor sich entwickelnden digitalen Bedrohungen.
          </p>
        </div>
        <img
          src={Image}
          className="w-full object-cover rounded-xl h-150"
          alt="Relume placeholder image"
        />
      </div>
    </section>
  );
}
